import React from "react";
import { Breadcrumb } from "reactstrap";
import {
  BreadcrumbCustomItem,
  type BreadcrumbCustomItemProps,
} from "components/ProductConfigurator/components/Breadcrumb/BreadcrumbCustomItem";

export type BreadcrumbItem = Pick<
  BreadcrumbCustomItemProps,
  "title" | "handleClick"
> & {
  [key: string]: unknown;
};

type BreadCrumbsProps = {
  breadcrumbList: BreadcrumbItem[];
  classNames?: string;
};

export const BreadCrumbs = ({
  breadcrumbList,
  classNames,
}: BreadCrumbsProps) => (
  <Breadcrumb listTag="div" className={classNames}>
    {breadcrumbList.map((item, index) => (
      <BreadcrumbCustomItem
        key={index}
        title={item.title}
        handleClick={item.handleClick}
        isLastItem={index === breadcrumbList.length - 1}
        withChevron={index}
      />
    ))}
  </Breadcrumb>
);
